import React from "react";
import styled from "styled-components";
import axios from "axios";
import { useState } from "react";
import http from "../services/http";
import auth from "../services/auth";
import { Redirect, useHistory } from "react-router-dom";
import { useEffect } from "react";

function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    formData[name] = value;
    setFormData({ ...formData });
  };

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await auth.login(formData);
      const currentUser = await auth.getCurrentUser();
      return (window.location = "/admin");
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Container>
      <h1>Ellinor Nielsen Login</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <input
            label={"Email"}
            name={"email"}
            type={"email"}
            placeholder={"Email"}
            onChange={handleChange}
            value={formData.email}
          />
        </div>
        <div>
          <input
            label={"Password"}
            name={"password"}
            type={"password"}
            placeholder={"Password"}
            onChange={handleChange}
            value={formData.password}
          />
        </div>
        <button onClick={onsubmit}>Login</button>
      </form>
    </Container>
  );
}

export default Login;

const Container = styled.div`
  height: 50vh;
  width: 40vw;
  background: rgba(162, 97, 23, 0.59);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(9.5px);
  -webkit-backdrop-filter: blur(9.5px);
  border: 1px solid rgba(162, 97, 23, 0.98);
  position: absolute;
  z-index: 999;
  left: 29vw;
  top: 20vh;
  opacity: 0.8;
  display: grid;
  place-content: center;
  @media screen and (max-width: 1000px) {
    margin-left: -10%;
    width: 70%;
    height: 30lvh;
  }

  h1 {
    @media screen and (max-width: 1000px) {
      place-self: center;
      font-size: 42px;
    }
  }

  input {
    height: 40px;
    width: 300px;
    margin: 20px;
    border-radius: 5px;
    font-size: 22px;
    border: 2px solid white;
    box-shadow: 0 0 12px white;
    font-style: italic;
    @media screen and (max-width: 1000px) {
      height: 60px;
      width: 600px;
    }
  }

  button {
    height: 40px;
    width: 200px;
    margin-left: 70px;
    border: 2px solid white;
    border-radius: 12px;
    box-shadow: 0 0 12px black;
    @media screen and (max-width: 1000px) {
      zoom: 200%;
    }
  }

  h1 {
    font-family: fantasy papyrus;
  }
`;
